import { Card, CardContent } from "@/components/ui/card";
import { CalendarCheck, Calendar, Gift } from "lucide-react";

const freeTools = [
  { icon: CalendarCheck, name: "Admission Eligibility Checker", desc: "Check student's eligible class instantly" },
  { icon: Calendar, name: "Holiday / Event Checker", desc: "View upcoming holidays and school events" },
];

export default function FreeToolsSection() {
  return (
    <section data-testid="free-tools-section" className="py-12 md:py-20 bg-white">
      <div className="container mx-auto px-4 md:px-6 max-w-5xl">
        <div className="flex items-center justify-center gap-2 mb-3">
          <Gift className="w-5 h-5 text-green-600" />
          <span className="text-green-700 font-semibold text-sm uppercase tracking-wide">Free Forever</span>
        </div>
        <h2
          data-testid="free-tools-headline"
          className="text-3xl md:text-4xl font-bold text-slate-900 text-center"
          style={{ fontFamily: "'Outfit', sans-serif" }}
        >
          Start Free — No Payment Required
        </h2>
        <p className="mt-3 text-center text-slate-600 text-sm md:text-base">
          After registration, teachers can immediately use these tools.
        </p>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6 max-w-2xl mx-auto">
          {freeTools.map((tool, i) => (
            <Card
              key={i}
              data-testid={`free-tool-card-${i}`}
              className="bg-green-50 border border-green-100 hover:border-green-300 transition-colors"
            >
              <CardContent className="p-6 text-center">
                <div className="w-12 h-12 rounded-xl bg-green-100 flex items-center justify-center mx-auto mb-4">
                  <tool.icon className="w-6 h-6 text-green-700" />
                </div>
                <h3 className="font-semibold text-slate-900 text-base" style={{ fontFamily: "'Outfit', sans-serif" }}>
                  {tool.name}
                </h3>
                <p className="mt-1 text-sm text-slate-500">{tool.desc}</p>
              </CardContent>
            </Card>
          ))}
        </div>

        <p className="mt-6 text-center text-green-700 font-medium text-sm">
          You can start using these tools instantly.
        </p>
      </div>
    </section>
  );
}
